import AuthService from '@/services/auth.service';

export default {
  namespaced: true,
  
  state: {
    user: null,
    token: null,
    isAuthenticated: false,
    loading: false,
    error: null
  },
  
  mutations: {
    SET_AUTH_DATA(state, { token, user }) {
      state.token = token;
      state.user = user;
      state.isAuthenticated = true;
      state.error = null;
      AuthService.saveAuthData(token, user);
    },
    
    SET_USER(state, user) {
      state.user = user;
    },
    
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    
    SET_ERROR(state, error) {
      state.error = error;
    },
    
    CLEAR_AUTH_DATA(state) {
      state.token = null;
      state.user = null;
      state.isAuthenticated = false;
      state.error = null;
      AuthService.logout();
    }
  },
  
  actions: {
    async login({ commit }, credentials) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', null);
      
      try {
        const response = await AuthService.login(credentials);
        const { token, user } = response.data;
        
        commit('SET_AUTH_DATA', { token, user });
        commit('SET_LOADING', false);
        
        return response.data;
      } catch (error) {
        const errorMessage = error.response?.data?.message || 'Login failed';
        commit('SET_ERROR', errorMessage);
        commit('SET_LOADING', false);
        throw error;
      }
    },
    
    logout({ commit }) {
      commit('CLEAR_AUTH_DATA');
    },
    
    async changePassword({ commit }, passwordData) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', null);
      
      try {
        const response = await AuthService.changePassword(passwordData);
        commit('SET_LOADING', false);
        return response.data;
      } catch (error) {
        const errorMessage = error.response?.data?.message || 'Password change failed';
        commit('SET_ERROR', errorMessage);
        commit('SET_LOADING', false);
        throw error;
      }
    },
    
    initializeAuth({ commit }) {
      const token = AuthService.getToken();
      const user = AuthService.getCurrentUser();
      
      if (token && user) {
        commit('SET_AUTH_DATA', { token, user });
      }
    }
  },
  
  getters: {
    isAuthenticated: (state) => state.isAuthenticated,
    currentUser: (state) => state.user,
    authToken: (state) => state.token,
    authError: (state) => state.error,
    isLoading: (state) => state.loading
  }
};